import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import "../../styles/hydiene-system/hydiene.css";
import HelmetWrapper from "../../HelmetWrapper";
import PageStarter from "../../components/hygiene-system/hygiene-common/PageStarter";
import { selectAuth } from "../../components/auth/auth.selector";

const HygieneManagement = () => {
  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;

  const [isPage, setIsPage] = useState(0);
  const iniAllFilter = {
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    limit: 10,
    page: isPage + 1,
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniModvalues = {
    isModOpen: false,
    cardName: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const onCloseModalvalues = () => {
    setModValues(iniModvalues);
  };

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
      setIsPage(0);
    }
  };

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
    }));
  }, [isPage]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Hygiene Management">
      <Container className="bg-cloud-k px-50px" fluid>
        <Row>
          <Col>
            <PageStarter
              pageName={"hygiene management"}
              searchPlaceHolder={"Gym"}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default HygieneManagement;
